<template>
  <vc-button @click="sendGaEvent('Support', 'support button click', 'Patreon')" tag="a" to="https://www.patreon.com/vuecidity" target="_blank" :class="['become-a-patron']">
    <img src="/static/images/patreon-logo.png" width="24" height="24" />Become a patron
  </vc-button>
</template>
<script>
import methods from '../../helpers/methods'

export default {
  name: 'PatreonButton',
  mixins: [
    methods
  ]
}
</script>
<style>
.become-a-patron
{
  background: #f96854 !important;
}

.become-a-patron img
{
  margin: 0 4px 0;
}

.become-a-patron.vc-button .vc-button-label
{
  padding-right: 4px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/patreon-button/PatreonButton.vue